import React, { ChangeEvent } from "react";

const useInput = () => {
  const handleTextChange = (
    event: ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
    setState: (newState: any) => void
  ) => {
    const { name, value } = event.target;
    setState((previousState: any) => ({
      ...previousState,
      [name]: value
    }));
  };

  const handleTextChangeArray = (
    event: ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
    index: number,
    setState: (newState: any) => void,
    arrayPath?: string
  ) => {
    const { name, value } = event.target;

    setState((previousState: any) => {
      const previousStateArray = arrayPath
        ? previousState[arrayPath]
        : previousState;

      let updatedArray = previousStateArray.map((prevItem: any, i: number) => {
        if (i === index) return { ...prevItem, [name]: value };
        return prevItem;
      });

      if (arrayPath) {
        return { ...previousState, [arrayPath]: updatedArray };
      } else {
        return updatedArray;
      }
    });
  };

  const handleNumberChangeArray = (
    event: ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
    index: number,
    setState: (newState: any) => void,
    arrayPath?: string
  ) => {
    const { name, value } = event.target;
    const resolvedValue = parseFloat(value.toString());

    setState((previousState: any) => {
      const previousStateArray = arrayPath
        ? previousState[arrayPath]
        : previousState;

      let updatedArray = previousStateArray.map((prevItem: any, i: number) => {
        if (i === index) return { ...prevItem, [name]: resolvedValue };
        return prevItem;
      });

      if (arrayPath) {
        return { ...previousState, [arrayPath]: updatedArray };
      } else {
        return updatedArray;
      }
    });
  };

  const handleDateChange = (
    propName: string,
    value: Date | null,
    setState: (newState: any) => void
  ) => {
    setState((previousState: any) => ({
      ...previousState,
      [propName]: convertDateToUtc(value) || value
    }));
  };

  const handleDateChangeArray = (
    propName: string,
    value: Date | null,
    index: number,
    setState: (newState: any) => void
  ) => {
    setState((previousState: any) =>
      previousState.map((prevItem: any, i: number) => {
        if (i === index)
          return { ...prevItem, [propName]: convertDateToUtc(value) || value };
        return prevItem;
      })
    );
  };

  const handleSelectChange = (
    e: React.ChangeEvent<{ name?: string | undefined; value: any }>,
    setState: (newState: any) => void
  ) => {
    const { name, value } = e.target;
    if (name) {
      setState((previousState: any) => ({
        ...previousState,
        [name]: value
      }));
    }
  };

  const convertDateToUtc = (date: Date | null) => {
    let utcDate: Date | null = null;
    if (date) {
      let timestamp = Date.parse(date.toString());
      if (!isNaN(timestamp)) {
        utcDate = new Date(
          Date.UTC(
            date.getFullYear(),
            date.getMonth(),
            date.getDate(),
            date.getHours(),
            date.getMinutes(),
            date.getSeconds()
          )
        );
      }
    }

    return utcDate;
  };

  return {
    handleTextChange,
    handleTextChangeArray,
    handleNumberChangeArray,
    handleDateChange,
    handleDateChangeArray,
    handleSelectChange
  };
};

export default useInput;
